import Grid from '@mui/material/Grid';
import styles from 'assets/jss/Report/ReportStyle';
import { makeStyles } from '@mui/styles';
import { digitsEnToFa } from 'persian-tools2';

const useStyles = makeStyles(styles);

export default function SMBG(props) {
    const classes = useStyles();
    const testPerDay = Math.round(props?.testsPerDay * 10) / 10;

    const data = [
        { label: 'تعداد کل تست ها: ', value: props.totalRecordCount ? digitsEnToFa(props?.totalRecordCount) : '_' },
        { label: 'روزهایی که تست انجام شده:', value: props.daysWithTest ? digitsEnToFa(props?.daysWithTest) : '_' },
        { label: 'میانگین تعداد تست در هر روز:', value: testPerDay ? digitsEnToFa(testPerDay) : '_' },
        { label: 'تاریخ آخرین تست شما:', value: props.lastTestDate !== null ? digitsEnToFa(props?.lastTestDate) : '_' }
    ];

    return (
        <Grid container style={{ padding: '24px 20px' }}>
            {data.map(({ label, value }) => (
                <Grid container alignItems='center' mb='24px' justifyContent='space-between' xs={12} key={label}>
                    <Grid textAlign='right' xs={9}>
                        <span className={classes.SmbgSpan}>{label}</span>
                    </Grid>
                    <Grid item xs={3} textAlign='left'>
                        <span className={classes.dateSpanNumber}>
                            {value}
                        </span>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
}